export const PENDING_PAYMENT_KEY = 'tfd_pending_payment';
export const LAST_CONFIRMATION_KEY = 'tfd_last_confirmation';

export const PAYMENT_MODE_LABELS = {
  mock: 'Mock payments',
  stripe_test: 'Stripe test mode',
  stripe_live: 'Stripe live mode',
  paypal_test: 'PayPal sandbox',
  paypal_live: 'PayPal live mode',
};

export function getPaymentModeLabel(mode) {
  return PAYMENT_MODE_LABELS[mode] || 'Payments';
}

export function buildItemsSummary(items = []) {
  return items.map(item => {
    // Expedited (+$20) only applies to authentication items — mirror the cart and
    // backend (orders.py) guards so the confirmation total never overstates the charge
    // for an appraisal item that carries a stale is_expedited flag (CHK-11).
    const expeditedCents = item.is_expedited && item.service_family === 'authentication' ? 2000 : 0;
    return {
      item_title: item.item_title || 'Untitled',
      service_family: item.service_family,
      category_name: item.category_name || item.category_slug,
      is_expedited: item.is_expedited,
      wants_mailed_document: item.wants_mailed_document,
      total_cents: (item.base_price_cents || 0) + expeditedCents + (item.wants_mailed_document ? 1000 : 0),
    };
  });
}

export function buildPendingPayment({ orderId, orderNumber, totalCents, clientSecret, paymentIntentId, paymentId, items = [] }) {
  return {
    order_id: orderId,
    order_number: orderNumber,
    total_cents: totalCents,
    client_secret: clientSecret,
    payment_intent_id: paymentIntentId,
    payment_id: paymentId,
    items_count: items.length,
    items_summary: buildItemsSummary(items),
  };
}

export function savePendingPayment(payload) {
  try {
    sessionStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify(payload));
  } catch {}
}

export function readPendingPayment() {
  try {
    const raw = sessionStorage.getItem(PENDING_PAYMENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingPayment() {
  try {
    sessionStorage.removeItem(PENDING_PAYMENT_KEY);
  } catch {}
}

export function storeConfirmation(payload) {
  try {
    sessionStorage.setItem(LAST_CONFIRMATION_KEY, JSON.stringify(payload));
  } catch {}
}